import { Box, Text, VStack } from '@chakra-ui/react'

export const AlertPanel = () => {
  return (
    <Box p={4} bg="white" borderRadius="lg" shadow="sm">
      <Text fontSize="lg" fontWeight="bold" mb={4}>Alerts & Status</Text>
      <VStack align="stretch" spacing={3}>
        {/* Alert items will go here */}
      </VStack>
    </Box>
  )
}
